module.exports = __webpack_public_path__ + "img/finish-testscreen.f87994c0.svg";